import {Decorators, Decorator} from '../config/getterConfig'
import { reduce } from 'lodash'

export function decorate<T>(target: T, decorators: Decorators<T>) {
  return reduce(
    [].concat(decorators),
    (acc: T, decorator: Decorator<T>) => decorator(acc),
    target
  )
}